import { render } from "./NewOurProjectsfile.vue?vue&type=template&id=7ae80d1b"
const script = {}

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__